<template>
  <a-config-provider :locale="zhCN">
    <LayoutVue></LayoutVue>
  </a-config-provider>
</template>

<script setup>
  import 'dayjs/locale/zh-cn'
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import LayoutVue from './components/LayoutVue.vue'
  import {
    isWindows
  } from 'vue-device-detect'

  if (isWindows) {
    let link = document.createElement("link")
    link.href = "./css/scrollbar.css"
    link.rel = "stylesheet"
    link.type = "text/css"

    document.head.appendChild(link)
  }
</script>

<style lang="scss">
  #app {
    text-align: center;
    color: rgba(43, 43, 43, 1);
    width: 100vw;
    height: 100vh;
    overflow: auto;
  }

  body {
    margin: 0;
  }

  div {
    cursor: default;
  }
</style>
